import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import { Heart, LogOut, User2 } from "lucide-react";

export default function Header() {
  const { user, logout } = useAuth();
  const { t } = useTranslation();
  const nav = useNavigate();

  const navLinkClass = ({ isActive }) =>
    `text-sm font-medium transition-colors ${
      isActive ? "text-[#3F6147]" : "text-[#1F2A24] hover:text-[#5B8C66]"
    }`;

  return (
    <header className="glass-header sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center group" data-testid="header-logo" aria-label="doing-good.org home">
          <span className="font-black text-lg tracking-tight leading-none">
            doing<span className="text-[#5B8C66]">-good</span>.org
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          <NavLink to="/offers" className={navLinkClass} data-testid="nav-explore">{t("header.explore")}</NavLink>
          <NavLink to="/list-offer" className={navLinkClass} data-testid="nav-list-offer">{t("header.for_organizations", { defaultValue: "For organizations" })}</NavLink>
          {user && user.role === "admin" && (
            <NavLink to="/admin" className={navLinkClass} data-testid="nav-admin">{t("header.admin")}</NavLink>
          )}
        </nav>

        <div className="flex items-center gap-3">
          <LanguageSwitcher />
          {user ? (
            <>
              <Link to="/favorites" className="hidden sm:inline-flex items-center gap-1.5 text-sm font-medium text-[#1F2A24] hover:text-[#5B8C66] transition" data-testid="nav-favorites">
                <Heart size={16} strokeWidth={1.8} /> {t("header.saved")}
              </Link>
              <span className="hidden md:inline-flex items-center gap-1.5 text-sm text-[#5F6B61]">
                <User2 size={16} strokeWidth={1.8} /> {user.name}
              </span>
              <button
                onClick={async () => { await logout(); nav("/"); }}
                className="btn-pill inline-flex items-center gap-1.5 px-4 py-2 text-sm font-semibold border border-[#DED7C7] hover:border-[#5B8C66] hover:text-[#5B8C66] transition"
                data-testid="header-logout-btn"
              >
                <LogOut size={14} strokeWidth={2} /> {t("header.signout")}
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="text-sm font-semibold text-[#1F2A24] hover:text-[#5B8C66] transition" data-testid="header-login-link">
                {t("header.signin")}
              </Link>
              <Link to="/register" className="btn-pill px-4 py-2 text-sm font-semibold bg-[#5B8C66] text-white hover:bg-[#3F6147] transition" data-testid="header-register-link">
                {t("header.join")}
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
